<template>
  <div class="expense-modal">
    <form autocomplete="off" @submit.prevent.stop="addExpense" v-if="!isFinished">
      <div class="columns mb-1 mt-2">
        <div class="column col-3 col-md-12 col-sm-12 form-group">
          <select class="form-select" v-model="filterBySchedule">
            <option value="schedule">Da agenda</option>
            <option value="insurance">Da tabela do convênio</option>
            <option value="other_expense">Outras despesas</option>
          </select>
        </div>
        <div
          class="column col-9 col-md-12 col-sm-12 form-group"
          :class="!canSearch ? 'tooltip' : ''"
          :data-tooltip="!canSearch ? 'Convênio e profissional devem estar selecionados' : ''"
        >
          <dx-autocomplete
            v-model="expense"
            :source="findExpense"
            label="name"
            track-by="id"
            :disabled="!canSearch"
            :debounce="800"
            @select="addAppointmentExpense"
            placeholder="Informe o código ou nome da consulta ou outros..."
            input-id="expense-name"
          >
            <template v-slot="{ item }">
              <a>
                <fa-icon :icon="['fal', 'file-medical-alt']" class="text-primary"/>
                <span class="ml-1">
                  {{ item.expense.code | tuss }} - {{ item.expense.name }}
                </span>
              </a>
            </template>
            <template v-slot:action>
              <button
                type="button"
                @click="openExpenseModal"
                class="btn btn-action input-group-btn btn-icon btn-neutral"
                :class="{loading: expenseModal.loading}"
                tabindex="-1"
                :disabled="!canSearch || expenseModal.loading"
              ><fa-icon :icon="['fal', 'search']" /></button>
            </template>
          </dx-autocomplete>
        </div>
      </div>
    </form>

    <div class="loading loading-lg" v-if="loadingExpenses" />
    <template v-else>
      <div class="legacy-billing-bar" v-if="canDeleteAllLegacy">
        <div class="legacy-billing-info">
          <fa-icon :icon="['fal', 'info-circle']" class="text-secondary" />
          <span class="ml-2">
            Este agendamento está no faturamento antigo. Exclua todos os lançamentos
            para passar para o faturamento novo.
          </span>
        </div>
        <button class="btn btn-error"
                :class="{loading: deleting}"
                :disabled="deleting || editing || printing"
                @click="removeAllLegacyAccounts">
          Excluir todos os lançamentos
        </button>
      </div>
      <template v-if="groupedAccounts.length > 0">
        <div v-for="(account) in groupedAccounts" :key="account.key">
          <div class="account hide-sm">
            <div class="columns">
              <div class="column hide-sm" style="align-self: center">
              <span class="tooltip tooltip-right"
                    :data-tooltip="account.id
                    ? 'Lista de serviços finalizados' : 'Lista de serviços agendados'">
                <fa-icon
                  :icon="['fal', 'info-circle']"
                  class="text-secondary">
                </fa-icon>
              </span>
                <span class="ml-2">
                {{ account.id ? 'Finalizada' : 'Agendadas' }}
              </span>
                <span class="ml-1 text-bold">{{ total(account) | currency }}</span>
              </div>
              <div id="div-register-service" class="column text-right" v-if="!account.id">
                <button class="btn btn-info"
                        :class="{loading: isWaiting}"
                        :disabled="!isSelected || isWaiting || !form.insurance.plan.settings.id"
                        @click="checkAppointment"
                        v-if="!form.insurance.plan.settings.tiss.enabled && !isFinished">
                  Registrar atendimento
                </button>
                <dx-dropdown
                  v-if="form.insurance.plan.settings.tiss.enabled && !isFinished"
                  :items="referralTypes"
                  :disabled="!isSelected || isWaiting  || !form.insurance.plan.settings.id"
                  @select="selectReferralType"
                  label="name"
                  direction="right">
                  <button class="btn btn-info"
                          :class="{loading: isWaiting}"
                          :disabled="!isSelected || isWaiting || !form.insurance.plan.settings">
                    Registrar atendimento</button>
                </dx-dropdown>
              </div>
              <div class="column text-right" v-else>
                <button class="btn btn-sm btn-gray btn-icon btn-action"
                        :class="[fiscalDocument.loading ? 'loading' : 'tooltip']"
                        data-tooltip="Nota fiscal"
                        :disabled="!account.id || deleting || editing || printing"
                        v-if="total(account) > 0"
                        @click="openFiscalDocumentModal(account)">
                  <fa-icon :icon="['fal', 'file-invoice-dollar']"></fa-icon>
                </button>
                <button class="btn btn-sm btn-gray btn-icon btn-action tooltip ml-1"
                        data-tooltip="Editar"
                        :disabled="!account.id || deleting || editing || printing"
                        v-if="!isFinished"
                        @click="editAccountModal(account.id)">
                  <fa-icon :icon="['fal', 'pencil']"></fa-icon>
                </button>
                <button class="btn btn-sm btn-gray btn-action btn-icon tooltip ml-1"
                        data-tooltip="Guia de solicitação"
                        v-if="form.insurance.plan.settings.tiss.enabled"
                        :disabled="!account.id || deleting || editing || printing"
                        @click="printRequest(account.id)">
                  <fa-icon :icon="['fal', 'file-medical-alt']"></fa-icon>
                </button>
                <button class="btn btn-sm btn-gray btn-icon btn-action tooltip ml-1"
                        data-tooltip="Imprimir"
                        :disabled="!account.id || deleting || editing || printing"
                        @click="printAccount(account.id)">
                  <fa-icon :icon="['fal', 'print']"></fa-icon>
                </button>
                <button class="btn btn-sm btn-gray btn-icon
                btn-action tooltip tooltip-left ml-1"
                        data-tooltip="Excluir conta"
                        v-if="!isFinished && !canDeleteAllLegacy"
                        :disabled="!account.id || deleting || printing"
                        @click="removeAccountAppointment(account.id)">
                  <fa-icon :icon="['fal', 'times']"></fa-icon>
                </button>
              </div>
            </div>
          </div>
          <div>
            <table class="table expense-modal-table"
                   :class="account.id ? 'account-finished' : 'table-hover'">
              <tbody>
              <tr v-for="(item) in account.expenses" :key="item.key">
                <td class="text-center hide-sm">
                  <template v-if="item.accountId !== null">
                    <fa-icon :icon="['fal', 'file-medical-alt']"></fa-icon>
                  </template>
                  <template v-else>
                    <div class="form-group" v-if="!isFinished">
                      <label class="form-checkbox">
                        <input type="checkbox" v-model="item.selected">
                        <i class="form-icon"></i>
                      </label>
                    </div>
                  </template>
                </td>
                <td>{{ item.expense.code | tuss }} - {{ item.expense.name }}</td>
                <td>
                  <label class="form-switch" v-if="item.expense.type === 'consultation'">
                    <input type="checkbox" v-model="item.return"
                           :disabled="account.id" @change="changeExpenseReturn">
                    <i class="form-icon"></i>Retorno
                  </label>
                  <button class="btn btn-sm btn-gray btn-action btn-icon tooltip"
                          data-tooltip="Preparo" v-else
                          @click="getPreparation(item.expense.id)">
                    <fa-icon :icon="['fal', 'info-circle']"></fa-icon>
                  </button>
                </td>
                <td class="text-center hide-sm">
                  <span v-if="account.id">x{{item.quantity}}</span>
                  <span v-else>
                  <st-input-number-step
                    v-model="item.quantity"
                    @input="getExpensePrice(item)"
                    :min-value="1"
                    :max-value="20"
                  />
                </span>
                </td>
                <td class="text-right hide-sm">
                  <small>Total</small><br>
                  <span v-if="item.return">R$ 0,00</span>
                  <span v-else>
                  {{ item.totalParticular | currency }}
                </span>
                </td>
                <td class="text-right" v-if="!isFinished">
                  <button class="btn btn-sm btn-error btn-action btn-icon tooltip"
                          data-tooltip="Excluir"
                          @click="deleteAppointmentExpense(item)"
                          v-if="!item.accountId">
                    <fa-icon :icon="['fal', 'times']"></fa-icon>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <dx-modal title="Informações de preparo"
                      v-model="preparationModal.show" size="lg"
                      v-if="preparationModal.show"
                      id="modal-preparation">
              <div class="preparation-content" v-html="preparation" />
              <template slot="footer">
                <button class="btn btn-gray mr-1"
                        :class="{loading: preparationModal.printing}"
                        :disabled="preparationModal.printing"
                        @click="print">
                  <fa-icon :icon="['fal', 'print']" />
                  Imprimir
                </button>
                <button class="btn" @click="preparationModal.show = false">Sair</button>
              </template>
            </dx-modal>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="empty">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'info-circle']" size="3x"/>
          </div>
          <p class="empty-title h5">Serviços, taxas e outras despesas</p>
          <p class="empty-subtitle">
            Nenhum serviço encontrado. Informe o código ou nome no campo acima.
          </p>
        </div>
      </template>
    </template>

    <dx-modal
      title="Lista de serviços, taxas e outras despesas"
      v-model="expenseModal.show" size="lg"
      v-if="expenseModal.show"
      id="modal-expenses-appointment"
    >
      <div class="loading loading-lg mt-2" v-if="expenseModal.loading" />
      <template v-else>
        <div class="columns">
          <div class="column col-3 form-group">
            <select class="form-select" v-model="filterBySchedule" @change="searchExpenseModal">
              <option value="schedule">Da agenda</option>
              <option value="insurance">Da tabela do convênio</option>
              <option value="other_expense">Outras despesas</option>
            </select>
          </div>
          <div class="column col-9 form-group">
            <div class="input-group">
              <input
                type="text"
                class="form-input"
                id="search"
                v-model="expenseModal.search"
                v-focus
                @keydown.enter="searchExpenseModal"
                placeholder="Digite parte do nome ou código e tecle [Enter]"
              >
              <button
                class="btn btn-neutral btn-icon btn-action input-group-btn"
                :disabled="expenseModal.loading"
                :class="{loading: expenseModal.loading}"
                @click="searchExpenseModal"
              ><fa-icon :icon="['fal', 'search']" />
              </button>
            </div>
          </div>
        </div>
        <div class="empty mt-2"
             v-if="expenseModal.data.items.length === 0 && !expenseModal.loading">
          <div class="empty-icon">
            <fa-icon :icon="['fal', 'info-circle']" size="2x"/>
          </div>
          <p class="empty-title h6">Serviços, taxas e outras despesas</p>
          <p class="empty-subtitle">
            Nenhum serviço encontrado para esta agenda. Verifique as configurações.
          </p>
        </div>
        <table class="table table-hover expense-modal-table" v-else>
          <thead>
          <tr>
            <th style="width: 85px">Código</th>
            <th>Nome</th>
            <th class="text-right">Valor Paciente</th>
          </tr>
          </thead>
          <tbody>
          <tr class="c-hand" v-for="(item, i) in expenseModal.data.items" :key="i"
              @click="selectExpense(item)">
            <td>
              <span v-if="item.code">{{ item.code | tuss }}</span>
              <span v-else>-</span>
            </td>
            <td>{{ item.expense.name | capitalizeWord }}</td>
            <td class="text-right">
              {{ item.definition.particularValue | currency }}
            </td>
          </tr>
          </tbody>
        </table>
        <div class="load-more" v-if="expenseModal.data.items.length > 0">
          <button
            v-if="expenseModal.data.hasMore && !loading"
            class="btn btn-primary"
            @click="loadMore"
            :disabled="expenseModal.loadingMore"
            :class="{ loading: expenseModal.loadingMore }"
          >Carregar mais...</button>
        </div>
      </template>
      <template slot="footer">
        <button class="btn" @click="expenseModal.show = false">Sair</button>
      </template>
    </dx-modal>

    <referral-modal
      v-if="account.show"
      :show="account.show"
      :data="account.data"
      :source="source"
      :type="account.type"
      @close="hideAccountModal"
    />

    <fiscal-document
      v-if="fiscalDocument.show"
      :show="fiscalDocument.show"
      :entity="fiscalDocument.entity"
      :total-amount="fiscalDocument.totalAmount"
      :origin-type="fiscalDocument.origin?.type"
      :origin-id="fiscalDocument.origin?.id"
      @loading="fiscalDocument.loading = $event"
      @close="closeFiscalDocumentModal"
    />
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import moment from 'moment';
import FiscalDocument from '@/components/fiscal-document/FiscalDocument.vue';
import hasIssuedFiscalDocument from '@/components/fiscal-document/hasIssuedDocument';
import currency from '@/filters/currency';
import {
  isEnabled as isInsuranceBillingEnabled,
  opensLegacyScreen,
} from '@/app/billing/guide/service';
import ReferralModal from './Referral.vue';

export default {
  props: {
    saving: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ReferralModal,
    FiscalDocument,
  },
  data() {
    return {
      source: 'appointments',
      editing: false,
      printing: false,
      deleting: false,
      loading: false,
      loadingExpenses: false,
      expense: null,
      referralType: null,
      filterBySchedule: 'schedule',
      expenseModal: {
        loading: false,
        loadingMore: false,
        show: false,
        search: '',
        data: {
          items: [],
          hasMore: false,
          limit: 30,
          offset: 0,
        },
      },
      preparationModal: {
        show: false,
        printing: false,
        expenseId: '',
        preparation: '',
      },
      account: {
        type: '',
        data: {},
        show: false,
      },
      fiscalDocument: {
        loading: false,
        show: false,
        id: null,
        origin: null,
        totalAmount: 0,
        entity: null,
      },
    };
  },
  created() {
    this.form.expenses.forEach((item) => {
      item.selected = true;
      return item;
    });
  },
  computed: {
    ...mapState({
      form: state => state.appointment.form,
      user: state => state.auth.user,
    }),
    ...mapGetters({
      getProfessionalById: 'getProfessionalById',
    }),
    groupedAccounts() {
      return this.form.expenses
        .reduce((result, expense) => {
          let found = result.find(({ id }) => expense.accountId === id);
          if (!found) {
            found = {
              id: expense.accountId,
              key: expense.accountId || 'no-account',
              expenses: [],
            };
            result.push(found);
          }
          found.expenses.push(expense);
          return result;
        }, [])
        .sort((a, b) => {
          if (!a.id) return -1;
          if (!b.id) return 1;
          return 0;
        });
    },
    isSelected() {
      return this.form.expenses
        .some(item => item.accountId === null && item.selected);
    },
    isWaiting() {
      return this.deleting || this.loading || this.saving;
    },
    canSearch() {
      return this.form.insurance.plan.id && this.form.professional.id;
    },
    preparation() {
      if (!this.preparationModal.preparation) return '';

      return this.preparationModal.preparation
        .replace(/(<figure([^>]+)>)/ig, '')
        .replace(/<\/figure>/ig, '')
        .replace(/<table>/ig, '<table class="table">');
    },
    referralTypes() {
      const sadt = this.form.insurance.plan.settings.tiss.consultationInSadt;
      const items = [];
      if (!sadt) {
        items.push({ code: 'consultation', name: 'Guia de Consulta' });
      }
      items.push({ code: 'sadt', name: 'Guia de SP/SADT' });
      return items;
    },
    isFinished() {
      const allowEditFinishedAppointment = this.user.branch.settings
      && this.user.branch.settings['clinical.allowEditFinishedAppointment']
        ? this.user.branch.settings['clinical.allowEditFinishedAppointment']
        : false;
      return !!this.form.service.finishedAt && !allowEditFinishedAppointment;
    },
    canDeleteAllLegacy() {
      return isInsuranceBillingEnabled(this.user)
        && !!this.form.id
        && !this.isFinished
        && opensLegacyScreen(this.form.expenses);
    },
    isFiscalDocumentEnabled() {
      const settings = this.user.branch
        && this.user.branch.settings
        && this.user.branch.settings.fiscalDocument;
      return !!(settings && settings.enabled);
    },
  },
  methods: {
    ...mapMutations({
      showAccountModal: 'Appointment.SHOW_ACCOUNT_MODAL',
      addExpense: 'Appointment.ADD_EXPENSE',
      deleteExpense: 'Appointment.DELETE_EXPENSE',
      setAccount: 'Appointment.SET_ACCOUNT',
      applyBillingSnapshot: 'Appointment.APPLY_BILLING_SNAPSHOT',
    }),
    total(account) {
      return account.expenses
        .reduce((a, b) => a + Number(b.totalParticular), 0);
    },
    findExpense(search) {
      const params = {
        search,
        insuranceId: this.form.insurance.id,
        planId: this.form.insurance.plan.id,
        date: moment(this.form.startDate).format('YYYY-MM-DD'),
        limit: 30,
        offset: 0,
      };

      let url = `/professionals/${this.form.professional.id}/expense-prices`;

      if (this.filterBySchedule === 'schedule') {
        params.scheduleId = this.form.schedule.id;
      } else if (this.filterBySchedule === 'other_expense') {
        const types = [
          'daily',
          'gas',
          'material',
          'medicine',
          'others',
          'service',
          'surgery',
          'tax',
        ];
        params.types = types.join(',');
        url = '/expense-insurances';
      }

      return this.$httpX
        .get(url, { params })
        .then(({ data }) => {
          if (data.items.length === 0) {
            return [{
              id: null,
              diagnostic: true,
              search,
              expense: {
                id: null,
                type: null,
                name: 'Serviço não encontrado neste convênio. Clique para ver por quê',
              },
              quantity: 0,
              factor: 1,
              definition: {
                insuranceValue: 0,
                particularValue: 0,
              },
            }];
          }
          return data.items;
        });
    },
    openDiagnostic(search) {
      this.$store.commit('Appointment.SHOW_DIAGNOSTIC_MODAL', {
        scheduleId: this.form.schedule && this.form.schedule.id
          ? this.form.schedule.id
          : this.form.scheduleId,
        date: moment(this.form.startDate).format('YYYY-MM-DD'),
        planId: this.form.insurance.plan.id,
        search,
      });
    },
    async addAppointmentExpense(expense, quantityToAdd = 1) {
      if (expense && expense.diagnostic) {
        this.openDiagnostic(expense.search);
        return;
      }

      if (!expense || expense.expense.id === null) {
        return;
      }

      this.loadingExpenses = true;

      const {
        insuranceValue,
        particularValue,
        secondSegment,
      } = expense.definition;

      let totalInsurance = insuranceValue;
      let totalParticular = particularValue;

      const foundExpense = this.form.expenses
        .find(item => item.expense.id === expense.expense.id);

      const quantity = (foundExpense ? foundExpense.quantity : 0) + quantityToAdd;

      if (quantity > 1) {
        const percent = (secondSegment || 100) / 100;
        const remaining = quantity - 1;

        totalInsurance = insuranceValue + insuranceValue * remaining * percent;
        totalParticular = particularValue + particularValue * remaining * percent;
      }

      if (foundExpense) {
        foundExpense.quantity = quantity;
        foundExpense.totalInsurance = totalInsurance;
        foundExpense.totalParticular = totalParticular;
      } else {
        this.addExpense({
          id: null,
          isNew: true,
          selected: true,
          accountId: null,
          expense: {
            id: expense.expense.id,
            code: expense.code,
            type: expense.expense.type,
            name: expense.expense.name,
            specialty: expense.expense.specialty || null,
          },
          return: false,
          quantity,
          factor: 1,
          totalInsurance,
          totalParticular,
        });
      }

      if ((totalInsurance + totalParticular) === 0) {
        this.$toast.show('Atenção! Serviço ainda não precificado.', { type: 'error' });
      }

      this.$emit('validateScheduleInfo');

      if (expense.hasPreparation) {
        this.getPreparation(expense.expense.id);
      }

      if (expense.hasAggregates) {
        await this.addAggregates(expense.expense.id);
      }

      this.loadingExpenses = false;
      this.expense = null;
    },
    async addAggregates(id) {
      const params = {
        insuranceId: this.form.insurance.id,
        planId: this.form.insurance.plan.id,
        professionalId: this.form.professional.id,
      };

      await this.$http.get(`/expenses/${id}/aggregates`, { params })
        .then(({ data }) => {
          data.items.forEach((item) => {
            this.addAppointmentExpense(item, item.quantity || 1);
          });
        })
        .catch(() => {
          this.$toast.show('Erro ao carregar agregados.', { type: 'error' });
        });
    },
    print() {
      this.preparationModal.printing = true;
      return this.$file
        .print(`/expenses/${this.preparationModal.expenseId}/print-preparation`)
        .catch(() => {})
        .finally(() => {
          this.preparationModal.printing = false;
        });
    },
    selectReferralType(item) {
      this.referralType = item.code;
      this.checkAppointment();
    },
    openExpenseModal() {
      this.expenseModal.search = '';
      this.searchExpenseModal();
      this.expenseModal.show = true;
    },
    searchExpenseModal() {
      this.expenseModal.data.items = [];
      this.expenseModal.data.hasMore = false;
      this.expenseModal.data.offset = 0;
      this.loadExpenseModalItems();
    },
    getExpensePrice(item) {
      const params = {
        insuranceId: this.form.insurance.id,
        planId: this.form.insurance.plan.id,
        expenseId: item.expense.id,
      };

      return this.$httpX
        .get(`/professionals/${this.form.professional.id}/expense-prices`, { params })
        .then(({ data }) => {
          if (data?.items.length > 0) {
            const {
              insuranceValue,
              particularValue,
              secondSegment,
            } = data.items[0].definition;

            if (item.quantity === 1) {
              item.totalInsurance = insuranceValue;
              item.totalParticular = particularValue;
            } else {
              const percent = (secondSegment || 100) / 100;
              const remaining = item.quantity - 1;
              item.totalInsurance = insuranceValue + insuranceValue * percent * remaining;
              item.totalParticular = particularValue + particularValue * percent * remaining;
            }
          }
        });
    },
    async loadExpenseModalItems() {
      const firstData = this.expenseModal.data.offset === 0;

      if (firstData) {
        this.expenseModal.loading = true;
      } else {
        this.expenseModal.loadingMore = true;
      }

      const params = {
        limit: this.expenseModal.data.limit,
        offset: this.expenseModal.data.offset,
        insuranceId: this.form.insurance.id,
        planId: this.form.insurance.plan.id,
        date: moment(this.form.startDate).format('YYYY-MM-DD'),
      };

      if (this.expenseModal.search) {
        params.search = this.expenseModal.search;
      }

      let url = `/professionals/${this.form.professional.id}/expense-prices`;

      if (this.filterBySchedule === 'schedule') {
        params.scheduleId = this.form.schedule.id;
      } else if (this.filterBySchedule === 'other_expense') {
        const types = [
          'daily',
          'gas',
          'material',
          'medicine',
          'others',
          'service',
          'surgery',
          'tax',
        ];
        params.types = types.join(',');
        url = '/expense-insurances';
      }

      this.$httpX.get(url, { params })
        .then(({ data }) => {
          this.expenseModal.data.hasMore = data.hasMore;
          this.expenseModal.data.items = firstData
            ? data.items
            : [...this.expenseModal.data.items, ...data.items];
        })
        .catch(() => {})
        .finally(() => {
          this.expenseModal.loading = false;
          this.expenseModal.loadingMore = false;
        });
    },
    async loadMore() {
      this.expenseModal.data.offset += this.expenseModal.data.limit;
      await this.loadExpenseModalItems();
    },
    selectExpense(item) {
      this.addAppointmentExpense(item);
      this.expenseModal.show = false;
    },
    deleteAppointmentExpense(expense) {
      this.deleteExpense(expense);
      this.changeExpenseReturn();
    },
    hideAccountModal() {
      this.account.show = false;
    },
    checkAppointment() {
      this.$emit('check-appointment');
    },
    changeExpenseReturn() {
      this.$emit('validateScheduleInfo');
    },
    findInsurancePlan(insuranceId, planId) {
      return this.$httpX.get(`/insurances/${insuranceId}/plans/${planId}`)
        .then(({ data }) => data)
        .catch(() => {});
    },
    async openAccount() {
      // Temp function
      const insurance = await this.findInsurancePlan(
        this.form.insurance.id,
        this.form.insurance.plan.id,
      );

      const tiss = this.referralType;

      let recordLength = 0;
      if (this.form.insurance.record) {
        recordLength = this.form.insurance.record.length;
      }
      if (this.form.insurance.plan.settings.record.required
        && this.form.insurance.plan.settings.record.requiredValidity) {
        if (recordLength === 0 && !this.form.insurance.validity) {
          this.$toast.show(
            'Informe o número e a validade da carteirinha do paciente na aba Agendamento!',
            { type: 'error' },
          );
          return;
        }
      }
      if (this.form.insurance.plan.settings.record.required) {
        if (recordLength === 0) {
          this.$toast.show('Informe a carteirinha do paciente na aba Agendamento!', { type: 'error' });
          return;
        }
      }
      if (this.form.insurance.plan.settings.record.requiredValidity) {
        if (!this.form.insurance.validity) {
          this.$toast.show('Informe a validade da carteirinha do paciente na aba Agendamento!', { type: 'error' });
          return;
        }
      }
      if (this.form.insurance.plan.settings.record.digits.enabled) {
        if (recordLength < this.form.insurance.plan.settings.record.digits.min) {
          this.$toast.show(`A carteirinha deve ter no mínimo ${this.form.insurance.plan.settings.record.digits.min} dígito(s)!`, { type: 'error' });
          return;
        }
        if (recordLength > this.form.insurance.plan.settings.record.digits.max) {
          this.$toast.show(`A carteirinha deve ter no máximo ${this.form.insurance.plan.settings.record.digits.max} dígito(s)!`, { type: 'error' });
          return;
        }
      }

      this.loading = true;

      let endDate = moment(this.form.startDate)
        .add(15, 'minutes')
        .format('YYYY-MM-DD[T]HH:mm');

      if (this.form.endDate && !moment(this.form.startDate).isSame(this.form.endDate)) {
        endDate = moment(this.form.endDate);
      }

      const professional = this.getProfessionalById(this.form.professional.id);

      const account = {
        id: '',
        appointmentId: this.form.id,
        professionalId: this.form.professional.id,
        specialtyCode: this.form.professional.specialty || null,
        key: this.form.key,
        startDate: this.form.startDate,
        endDate,
        patient: {
          id: this.form.patient.id,
          name: this.form.patient.name,
          birthDate: this.form.patient.birthDate,
          gender: this.form.patient.gender,
          cns: this.form.patient.cns ? this.form.patient.cns : '',
          insurance: {
            id: this.form.insurance.id,
            name: this.form.insurance.name || this.form.patient.insurance.name,
            plan: this.form.insurance.plan,
            insured: {
              record: this.form.insurance.record,
              validity: this.form.insurance.validity,
            },
          },
        },
        expenses: this.form.expenses
          .filter(item => item.selected && !item.accountId)
          .map((expense) => {
            const item = {
              id: expense.id,
              startDate: this.form.startDate,
              endDate,
              execution: {
                date: moment(this.form.startDate).format('YYYY-MM-DD'),
                time: moment(this.form.startDate).format('HH:mm'),
                duration: moment.duration(moment(endDate)
                  .diff(moment(this.form.startDate))).asMinutes(),
              },
              accountId: '',
              expense: expense.expense,
              return: expense.return || false,
              rules: {
                requireAuthorization: false,
                requireClinicalIndication: false,
                requireWayTechnique: false,
                definition: {},
              },
              quantity: expense.quantity,
              factor: expense.factor ? expense.factor : 1,
              way: '',
              technique: '',
              value: {
                particular: expense.totalParticular / expense.quantity,
                insurance: expense.totalInsurance / expense.quantity,
                total: expense.totalParticular + expense.totalInsurance,
              },
              professional: {
                id: this.form.professional.id,
                name: professional ? professional.name : this.form.professional.name,
                council: professional ? professional.council : this.form.professional.council,
                specialty: {
                  code: this.form.professional.specialty,
                },
                degreeParticipation: 'clinical',
              },
            };

            return item;
          }),
      };

      const params = {
        expenseIds: account.expenses.map(({ expense }) => expense.id).join(','),
      };

      await this.$httpX.get(`/expense-insurances/${this.form.insurance.plan.id}/rules`, { params })
        .then(({ data }) => {
          if (data.items) {
            if (data.items.length > 0) {
              data.items.forEach((item) => {
                account.expenses.forEach((expense) => {
                  if (item.id === expense.expense.id) {
                    if (item.rules) {
                      expense.rules = item.rules;
                    }
                  }
                });
              });
            }
          }
        });

      if (tiss) {
        if (this.form.insurance.plan.settings.tiss.consultationInSadt) {
          this.account.type = 'sadt';
        } else {
          this.account.type = tiss;
        }
      } else {
        this.account.type = insurance?.type || 'referral';
      }
      this.account.data = account;
      this.account.show = true;
      this.loading = false;
    },
    async printRequest(accountId) {
      this.printing = true;
      return this.$fileX
        .print(`/legacy/billing-accounts/${accountId}/printRequest`)
        .catch((e) => {
          if (e.response
            && e.response.data
            && e.response.data.message) {
            this.$toast.error(e.response.data.message, { timeout: 5000 });
          } else {
            this.$toast.error('Não foi possível realizar a impressão!');
          }
        })
        .finally(() => {
          this.printing = false;
        });
    },
    async printAccount(accountId) {
      this.printing = true;
      return this.$fileX
        .print(`/legacy/billing-accounts/${accountId}/print`)
        .then(() => {
          this.printing = false;
        });
    },
    async blockedByFiscalDocument(id, action) {
      // Sem o recurso de notas ativo não há o que consultar.
      if (!this.isFiscalDocumentEnabled) return false;

      const has = await hasIssuedFiscalDocument(this.$http, 'billing_account', id);
      if (has) {
        this.$dialog.show('Ação não permitida', {
          type: 'danger',
          html: 'Esta conta possui uma nota fiscal emitida. '
            + `Cancele a nota fiscal antes de ${action} a conta.`,
        });
      }
      return has;
    },
    async editAccountModal(accountId) {
      if (await this.blockedByFiscalDocument(accountId, 'editar')) {
        return;
      }
      this.editing = true;
      let account;
      await this.$httpX.get(`/legacy/billing-accounts/${accountId}`)
        .then(({ data }) => {
          const professional = data.expenses.length > 0
            ? data.expenses[0].professional
            : null;
          if (data.invoice && data.invoice.id) {
            data.invoiceId = data.invoice.id;
          }
          data.professionalId = professional.id;
          data.specialtyCode = professional.specialty
            ? professional.specialty.code
            : null;
          data.key = this.form.key;
          data.expenses.forEach((expense) => {
            expense.accountId = accountId;
            expense.execution = {
              date: moment(expense.startDate).format('YYYY-MM-DD'),
              time: moment(expense.startDate).format('HH:mm'),
              duration: moment.duration(moment(expense.endDate)
                .diff(moment(expense.startDate))).asMinutes(),
            };
            expense.rules = {
              requireAuthorization: false,
              requireClinicalIndication: false,
              requireWayTechnique: false,
            };
          });
          account = data;
        });

      if (this.form.insurance.plan.settings.tiss.enabled) {
        const params = {
          expenseIds: account.expenses.map(({ id }) => id).join(','),
        };
        await this.$httpX.get(`/expense-insurances/${this.form.insurance.plan.id}/rules`, { params })
          .then(({ data }) => {
            if (data.items) {
              if (data.items.length > 0) {
                data.items.forEach((item) => {
                  account.expenses.forEach((expense) => {
                    if (item.id === expense.id) {
                      if (item.rules) {
                        expense.rules = item.rules;
                      }
                    }
                  });
                });
              }
            }
          });
        if (this.form.insurance.plan.settings.tiss.consultationInSadt) {
          this.account.type = 'sadt';
        } else {
          this.account.type = account.referral.type;
        }
      } else {
        this.account.type = account.patient.insurance.plan.type;
      }
      this.account.data = account;
      this.account.show = true;
      this.editing = false;
    },
    openFiscalDocumentModal(account) {
      this.fiscalDocument.totalAmount = this.total(account);
      this.fiscalDocument.entity = this.form.patient;
      this.fiscalDocument.origin = {
        type: 'billing_account',
        id: account.id,
      };
      this.fiscalDocument.show = true;
    },
    closeFiscalDocumentModal() {
      this.fiscalDocument.totalAmount = null;
      this.fiscalDocument.entity = null;
      this.fiscalDocument.origin = null;
      this.fiscalDocument.show = false;
    },
    removeAllLegacyAccounts() {
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Todas as guias e contas do faturamento antigo deste agendamento serão excluídas. '
          + 'Depois disso o agendamento passa para o faturamento novo.</div>'
          + '<div class="mt-2">Deseja realmente excluir todos os lançamentos?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              if (this.deleting) return;

              this.deleting = true;
              this.$httpX
                .delete(`/legacy/appointments/${this.form.id}/billing-accounts`)
                .then(({ data }) => {
                  this.applyLegacyRemoval(data);
                  close();
                })
                .catch((e) => {
                  close();
                  const data = e.response && e.response.data ? e.response.data : null;
                  if (data && data.reason === 'legacyAccountsLocked') {
                    this.showLegacyLocks(data.accounts || []);
                  } else if (data && data.message) {
                    this.$toast.show(data.message, { type: 'error', timeout: 5000 });
                  } else {
                    this.$toast.show('Não foi possível excluir os lançamentos.', { type: 'error' });
                  }
                })
                .then(() => {
                  this.deleting = false;
                });
            },
          },
        ],
      });
    },
    applyLegacyRemoval(appointment) {
      this.applyBillingSnapshot([appointment]);
      const removed = (appointment.expenses || [])
        .filter(({ accountId }) => !accountId)
        .map(({ id }) => String(id));
      this.form.expenses.forEach((expense) => {
        if (removed.includes(String(expense.id))) {
          expense.accountId = null;
          expense.selected = false;
        }
      });
      this.form.status = appointment.status;
      this.setAccount({
        key: this.form.key,
        expenses: this.form.expenses,
      });
    },
    showLegacyLocks(accounts) {
      const items = accounts.map((item) => {
        const group = this.groupedAccounts.find(({ id }) => id === item.accountId);
        const label = group ? `Conta de ${currency(this.total(group))}` : 'Conta';
        return `<li><strong>${label}:</strong> ${item.reason}</li>`;
      });
      this.$dialog.show('Ação não permitida', {
        type: 'danger',
        html: 'Nenhum lançamento foi excluído. Resolva o que impede a exclusão e tente novamente:'
          + `<ul class="mt-2">${items.join('')}</ul>`,
      });
    },
    async removeAccountAppointment(id) {
      if (await this.blockedByFiscalDocument(id, 'excluir')) {
        return;
      }
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente cancelar esta conta e estornar os serviços realizados?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              if (this.deleting) return;

              this.deleting = true;
              this.$httpX
                .delete(`/legacy/billing-accounts/${id}`)
                .then(() => {
                  this.$store.state.appointment.form.status = 'scheduled';
                  this.form.expenses.forEach((expense) => {
                    if (id === expense.accountId) {
                      expense.accountId = null;
                      expense.selected = false;
                    }
                  });
                  this.setAccount({
                    key: this.form.key,
                    expenses: this.form.expenses,
                  });
                  close();
                })
                .catch((e) => {
                  if (e.response
                    && e.response.data
                    && e.response.data.message) {
                    this.$toast.show(e.response.data.message, { type: 'error', timeout: 5000 });
                    close();
                  }
                })
                .then(() => {
                  this.deleting = false;
                });
            },
          },
        ],
      });
    },
    getPreparation(id) {
      this.$httpX.get(`/expenses/${id}`)
        .then(({ data }) => {
          if (data.preparation) {
            this.preparationModal.expenseId = id;
            this.preparationModal.preparation = data.preparation;
            this.preparationModal.show = true;
          } else {
            this.$toast.show('Serviço sem preparo cadastrado', { type: 'error' });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import 'src/assets/scss/variables';
.expense-modal {
  .legacy-billing-bar {
    align-items: center;
    background-color: $gray-color-ultra-light;
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    display: flex;
    gap: $layout-spacing;
    justify-content: space-between;
    margin: $layout-spacing 0;
    padding: $layout-spacing;
    .legacy-billing-info {
      align-items: center;
      display: flex;
    }
    @media screen and (max-width: $size-sm) {
      align-items: stretch;
      flex-direction: column;
    }
  }
  .account {
    background-color: #eee;
    padding: .4rem;
    border: 1px solid $border-color;
  }
  .account-finished {
    background-color: lighten($gray-color-light, 4%);
  }
  .expense-modal-table {
    td:first-child {
      width: 40px;
    }
    td:nth-child(3) {
      width: 100px;
    }
    td:nth-child(4) {
      width: 120px;
    }
    td:nth-child(5) {
      width: 80px;
    }
    td:nth-child(6) {
      width: 80px;
    }
    td:last-child {
      width: 50px;
    }
    @media screen and (max-width: $size-sm) {
      td:nth-child(3) {
        width: auto;
      }
    }
    border-left: 1px solid $border-color;
    border-right: 1px solid $border-color;
    &.table-hover {
      tr:hover {
        background-color: lighten($border-color, 6%);
      }
    }
  }
  #div-register-service li a:hover {
    background-color: $gray-color-light;
    color: black;
  }
}

#modal-expenses-appointment {
  .load-more {
    margin: $layout-spacing-lg 0;
    text-align: center;
    .btn {
      padding: 0 $layout-spacing-xl;
    }
  }
}

#modal-preparation {
  .preparation-content {
    background-color: $gray-color-ultra-light;
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    padding: $layout-spacing-lg;
    p {
      margin-bottom: $layout-spacing;
    }
  }
}
</style>
